import { render } from "./BoardDetailPage.vue?vue&type=template&id=3dd63fda"
import script from "./BoardDetailPage.vue?vue&type=script&lang=js"
export * from "./BoardDetailPage.vue?vue&type=script&lang=js"
script.render = render

export default script